import { SEGMENTOS } from "../data/segmentos";
import { trabajoPorPath } from "../data/trabajos";

export const WHATSAPP_NUMBER = "56946195159";

export const buildWhatsAppUrl = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const openWhatsApp = (message) => {
  window.open(buildWhatsAppUrl(message), "_blank", "noopener,noreferrer");
};

export const defaultWhatsAppMessage = (pathname = "/") => {
  const segmento = SEGMENTOS.find((item) => item.path === pathname);
  if (segmento) return segmento.whatsapp;

  const trabajo = trabajoPorPath(pathname);
  if (trabajo) return trabajo.whatsapp;

  const messages = {
    "/": "Hola Omega, tengo un evento y necesito fotógrafo. ¿Tienen la fecha disponible?",
    "/precios": "Hola Omega, vi los precios y quiero reservar una fecha.",
    "/portafolio": "Hola Omega, vi el portafolio y quiero algo similar.",
    "/sobre-omega": "Hola Omega, quiero saber cómo trabajan en eventos y en estudio.",
    "/contacto": "Hola Omega, quiero cotizar fotografía.",
  };

  return messages[pathname] || "Hola Omega, quiero cotizar fotografía.";
};
